/**
 * The two things the import review shows beside the list: what the file
 * offered but this build refused, and the passphrase box.
 *
 * The refusals are a visible list, not a console line, because a record that
 * disappears without explanation is indistinguishable from a record that was
 * never in the file — and the reasons here ("contains control or
 * text-direction characters") are exactly the ones a user should see before
 * trusting a file someone sent them.
 */
import { KeyRound } from 'lucide-react';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';

export function ImportSkippedList({ skipped }: { skipped: { index: number; reason: string }[] }) {
  if (skipped.length === 0) return null;
  return (
    <ul
      className="space-y-1 rounded-md border border-amber-500/40 bg-amber-500/5 p-2 text-xs text-muted-foreground"
      data-testid="connections-import-skipped"
    >
      {skipped.map((s) => (
        <li key={s.index}>
          Entry {s.index + 1} was not offered — {s.reason}
        </li>
      ))}
    </ul>
  );
}

export function ImportPassphraseField({
  value,
  onChange,
}: {
  value: string;
  onChange: (next: string) => void;
}) {
  return (
    <div className="space-y-1 rounded-md border border-border p-3">
      <Label htmlFor="connections-import-passphrase" className="flex items-center gap-2 text-xs">
        <KeyRound className="h-3.5 w-3.5" />
        Passphrase (this file includes saved passwords)
      </Label>
      <Input
        id="connections-import-passphrase"
        data-testid="connections-import-passphrase"
        type="password"
        autoComplete="off"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      <p className="text-xs text-muted-foreground">
        Leave blank to import the connections without their passwords.
      </p>
    </div>
  );
}
